import compact from 'lodash/compact';

export default value => {
  if (compact(value)) {
    const safeArr = compact([...value]);
    const isPresentTimeZone = safeArr.some(item => (item ? item.value : false));
    return (isPresentTimeZone && safeArr.length === 3) || safeArr.length === 0
      ? true
      : null;
  }

  return value;
};



// WEBPACK FOOTER //
// ./src/utils/validations/workingHoursValidator.js